import { render, staticRenderFns } from "./LinkParentalInformation.vue?vue&type=template&id=1c57fb79"
import script from "./LinkParentalInformation.vue?vue&type=script&lang=js"
export * from "./LinkParentalInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports